
import { Options, Vue } from 'vue-class-component';
import {
  Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot,
} from '@headlessui/vue';
import { XIcon } from '@heroicons/vue/outline';
import { LinkIcon, PlusIcon, QuestionMarkCircleIcon } from '@heroicons/vue/solid';
import SelectMenu from '@/components/SelectMenu.vue';
import ICategoryTemplate from '@/models/interfaces/ICategoryTemplate';
import CategoryTemplate from '@/models/CategoryTemplate';
import AreYouSureModal from '@/components/modals/AreYouSureModal.vue';

@Options({
  components: {
    AreYouSureModal,
    SelectMenu,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    LinkIcon,
    PlusIcon,
    QuestionMarkCircleIcon,
    XIcon,
  },
  props: {
    open: Boolean,
    editingItem: CategoryTemplate,
    templateId: String,
  },
  emits: [
    'closed',
  ],
})
export default class AddEditCategoryTemplateSlideOver extends Vue {
  open!: boolean;

  templateId!: string;

  areYouSureDeleteOpen = false;

  close(refresh = true): void {
    this.$emit('closed', true);
  }

  get selectedName() {
    console.log(this.$store.state);
    return this.$store.state.editingCategoryTemplate?.name;
  }

  set selectedName(val: string) {
    this.$store.dispatch('setEditCategoryTemplateName', val);
  }

  // eslint-disable-next-line class-methods-use-this
  get selectedDescription() {
    return this.$store.state.editingCategoryTemplate?.description;
  }

  // eslint-disable-next-line class-methods-use-this
  set selectedDescription(val: string) {
    this.$store.dispatch('setEditCategoryTemplateDescription', val);
  }

  get isEditing() {
    return !!this.$store.state.editingCategoryTemplate?.id;
  }

  get isNovice() {
    return this.$store.state.editingCategoryTemplate?.novice;
  }

  set isNovice(val: boolean) {
    this.$store.dispatch('setEditCategoryTemplateNovice', val);
  }

  get isPointsExcluded() {
    return this.$store.state.editingCategory?.isPointsExcluded;
  }

  set isPointsExcluded(val: boolean) {
    this.$store.dispatch('setEditCategoryTemplateIsPointsExcluded', val);
  }

  save(): void {
    console.log(this.$store.state.editingCategoryTemplate);
    if (this.$store.state.editingCategoryTemplate?.id) {
      this.axios.post(`${process.env.VUE_APP_APIURL}/templates/${this.templateId}/categories`, {
        name: this.selectedName,
        description: this.selectedDescription,
        id: this.$store.state.editingCategoryTemplate?.id,
        novice: this.isNovice,
        isPointsExcluded: this.isPointsExcluded,
      })
        .then(() => this.close(true));
    } else {
      this.axios.put(`${process.env.VUE_APP_APIURL}/templates/${this.templateId}/categories`, {
        name: this.selectedName,
        description: this.selectedDescription,
        novice: this.isNovice,
        isPointsExcluded: this.isPointsExcluded,
      })
        .then(() => this.close(true));
    }
  }

  deleteItem(): void {
    this.areYouSureDeleteOpen = true;
  }

  // eslint-disable-next-line class-methods-use-this
  confirmDelete(): void {
    console.log('deleting');
    this.axios.delete(`${process.env.VUE_APP_APIURL}/templates/${this.templateId}/categories/${this.$store.state.editingCategoryTemplate?.id}`)
      .then(() => {
        this.areYouSureDeleteOpen = false;
        this.close(true);
      });
  }
}
